export enum AuthRole {
  Renter = 'Renter',
  Landlord = 'Landlord',
  PropertyManagementCompany = 'PropertyManagementCompany',
  LeasingAgent = 'LeasingAgent',
  SuperUser = 'SuperUser'
}
